import { useEffect, useState } from "react";
import { Col, Row, Button, Card, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { CHAUFFEUR, UPLOADS_URL } from "../../../config/constants/api";
import DashbordSidebar from "../../../components/DashboardSidebar";
import { Get } from "../../../config/api/get";

const DropzoneFiltercards = () => {
  const [userData, setUserData] = useState(null);
  const user = useSelector((state) => state?.user?.userData);
  const token = useSelector((state) => state?.user?.userToken);
  const navigate = useNavigate();
  const [preview, setPreview] = useState({
    visible: false,
    src: "",
    title: "",
  });
  const getChauffeurProfile = () => {
    Get(`${CHAUFFEUR.getChauffeur}${user?._id}`, token)
      .then((response) => {
        if (response?.status) {
          setUserData(response?.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching Profile Information ", err);
      });
  };
  useEffect(() => {
    getChauffeurProfile();
    // eslint-disable-next-line
  }, []);
  return (
    <div className="shop-page">
      <Row style={{ width: "100%", justifyContent: "center" }}>
        <Col xs={23} md={21}>
          <div className="shop-page-main">
            <Row gutter={[16, 16]}>
              <Col xs={24} md={24} lg={24} xl={24}>
                <div className="my-account-profile">
                  <section className="side-menu-parent">
                    <DashbordSidebar />
                    {userData && (
                      <div className="about-us-section">
                        <div className="bg-parent">
                          <h3 className="main-heading">My Profile</h3>
                          <Row
                            gutter={[24, 24]}
                            align="stretch"
                            justify="space-between"
                          >
                            {/* Left: avatar & primary info */}
                            <Col md={10} lg={8} xl={8}>
                              <Card
                                bordered={false}
                                style={{
                                  borderRadius: 12,
                                  boxShadow:
                                    "0 6px 18px rgba(15, 23, 42, 0.05)",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                                bodyStyle={{ flex: 1, display: "flex", flexDirection: "column" }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    textAlign: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 160,
                                      height: 160,
                                      borderRadius: "50%",
                                      overflow: "hidden",
                                      marginBottom: 16,
                                      border: "2px solid #f0f0f0",
                                    }}
                                  >
                                    <img
                                      src={UPLOADS_URL + userData?.image}
                                      alt="Profile"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        objectPosition: "center",
                                      }}
                                    />
                                  </div>
                                  <div>
                                    <h2
                                      style={{
                                        margin: 0,
                                        fontSize: 22,
                                        fontWeight: 600,
                                        color: "#111827",
                                      }}
                                    >
                                      {userData?.firstName}{" "}
                                      {userData?.lastName}
                                    </h2>
                                    <p
                                      style={{
                                        marginTop: 4,
                                        marginBottom: 0,
                                        fontSize: 13,
                                        color: "#6b7280",
                                      }}
                                    >
                                      Chauffeur
                                    </p>
                                  </div>

                                  <div
                                    style={{
                                      marginTop: 16,
                                      width: "100%",
                                      borderTop: "1px solid #f3f4f6",
                                      paddingTop: 12,
                                      fontSize: 13,
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginBottom: 6,
                                        color: "#6b7280",
                                      }}
                                    >
                                      <span style={{ fontWeight: 500 }}>
                                        Phone:
                                      </span>{" "}
                                      <span style={{ color: "#111827" }}>
                                        {userData?.phone || "-"}
                                      </span>
                                    </div>
                                    <div style={{ color: "#6b7280" }}>
                                      <span style={{ fontWeight: 500 }}>
                                        Email:
                                      </span>{" "}
                                      <span style={{ color: "#111827" }}>
                                        {userData?.email || "-"}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Col>

                            {/* Right: documents */}
                            <Col md={14} lg={16} xl={16}>
                              {/* Documents */}
                              <Card
                                bordered={false}
                                title={
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                      color: "#111827",
                                    }}
                                  >
                                    Documents
                                  </span>
                                }
                                style={{
                                  borderRadius: 12,
                                  boxShadow:
                                    "0 6px 18px rgba(15, 23, 42, 0.05)",
                                  height: "100%",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                                headStyle={{ borderBottom: "1px solid #f3f4f6" }}
                                bodyStyle={{ flex: 1 }}
                              >
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns:
                                        "repeat(2, minmax(0, 1fr))",
                                      gap: 16,
                                    }}
                                  >
                                    {userData?.dmvFront && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={UPLOADS_URL + userData?.dmvFront}
                                          alt="DMV Front"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL +
                                                userData?.dmvFront,
                                              title: "DMV Front",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            DMV Front
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {userData?.dmvBack && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={UPLOADS_URL + userData?.dmvBack}
                                          alt="DMV Back"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL + userData?.dmvBack,
                                              title: "DMV Back",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            DMV Back
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {userData?.tlcFront && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={UPLOADS_URL + userData?.tlcFront}
                                          alt="TLC Front"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL +
                                                userData?.tlcFront,
                                              title: "TLC Front",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            TLC Front
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {userData?.tlcBack && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={UPLOADS_URL + userData?.tlcBack}
                                          alt="TLC Back"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL + userData?.tlcBack,
                                              title: "TLC Back",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            TLC Back
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {userData?.insurance && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={UPLOADS_URL + userData?.insurance}
                                          alt="Insurance"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL +
                                                userData?.insurance,
                                              title: "Insurance",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            Insurance
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {userData?.registeration && (
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: 8,
                                          alignItems: "center",
                                        }}
                                      >
                                        <img
                                          src={
                                            UPLOADS_URL + userData?.registeration
                                          }
                                          alt="Registerations"
                                          style={{
                                            width: 70,
                                            height: 70,
                                            objectFit: "cover",
                                            borderRadius: 8,
                                            border: "1px solid #e5e7eb",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            setPreview({
                                              visible: true,
                                              src:
                                                UPLOADS_URL +
                                                userData?.registeration,
                                              title: "Registerations",
                                            })
                                          }
                                        />
                                        <div>
                                          <div
                                            style={{
                                              fontSize: 13,
                                              fontWeight: 500,
                                              color: "#111827",
                                            }}
                                          >
                                            Registerations
                                          </div>
                                          <div
                                            style={{
                                              fontSize: 12,
                                              color: "#9ca3af",
                                            }}
                                          >
                                            Click to preview
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {!userData?.dmvFront &&
                                      !userData?.dmvBack &&
                                      !userData?.tlcFront &&
                                      !userData?.tlcBack &&
                                      !userData?.insurance &&
                                      !userData?.registeration && (
                                        <div
                                          style={{
                                            gridColumn: "1 / -1",
                                            fontSize: 13,
                                            color: "#9ca3af",
                                          }}
                                        >
                                          No documents uploaded yet.
                                        </div>
                                      )}
                                </div>
                              </Card>
                            </Col>
                          </Row>

                          {/* Payment section - Full width */}
                          <Row style={{ marginTop: 24 }}>
                            <Col span={24}>
                              <Card
                                bordered={false}
                                title={
                                  <span
                                    style={{
                                      fontSize: 16,
                                      fontWeight: 600,
                                      color: "#111827",
                                    }}
                                  >
                                    Payment Info
                                  </span>
                                }
                                style={{
                                  borderRadius: 12,
                                  boxShadow:
                                    "0 6px 18px rgba(15, 23, 42, 0.05)",
                                }}
                                headStyle={{ borderBottom: "1px solid #f3f4f6" }}
                              >
                                <Row gutter={[24, 0]}>
                                  <Col xs={24} sm={8}>
                                    <div>
                                      <span
                                        style={{
                                          display: "block",
                                          color: "#6b7280",
                                          fontWeight: 500,
                                          marginBottom: 2,
                                          fontSize: 13,
                                        }}
                                      >
                                        Name of Bank
                                      </span>
                                      <span style={{ color: "#111827", fontSize: 14 }}>
                                        {userData?.bankTitle || "-"}
                                      </span>
                                    </div>
                                  </Col>
                                  <Col xs={24} sm={8}>
                                    <div>
                                      <span
                                        style={{
                                          display: "block",
                                          color: "#6b7280",
                                          fontWeight: 500,
                                          marginBottom: 2,
                                          fontSize: 13,
                                        }}
                                      >
                                        Bank Account Number
                                      </span>
                                      <span style={{ color: "#111827", fontSize: 14 }}>
                                        {userData?.bankAccountNo || "-"}
                                      </span>
                                    </div>
                                  </Col>
                                  <Col xs={24} sm={8}>
                                    <div>
                                      <span
                                        style={{
                                          display: "block",
                                          color: "#6b7280",
                                          fontWeight: 500,
                                          marginBottom: 2,
                                          fontSize: 13,
                                        }}
                                      >
                                        Bank Routing Number
                                      </span>
                                      <span style={{ color: "#111827", fontSize: 14 }}>
                                        {userData?.routingNo || "-"}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              </Card>
                            </Col>
                          </Row>

                          {/* Actions */}
                          <Row style={{ marginTop: 24 }}>
                            <Col span={24}>
                              <div className="frame-group" style={{ display: "flex", gap: 12 }}>
                                <div style={{ flex: 1 }}>
                                  <Button
                                    type=""
                                    block
                                    size={"large"}
                                    className="web-btn"
                                    onClick={() =>
                                      navigate("/editProfile", {
                                        state: { userData },
                                      })
                                    }
                                  >
                                    Edit Profile
                                  </Button>
                                </div>
                                <div style={{ flex: 1 }}>
                                  <Button
                                    type=""
                                    block
                                    size={"large"}
                                    className="web-btn"
                                    onClick={() => navigate("/changePassword")}
                                  >
                                    Change password
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    )}
                  </section>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Modal
        open={preview.visible}
        title={preview.title}
        footer={null}
        onCancel={() => setPreview({ visible: false, src: "", title: "" })}
        centered
        width={600}
      >
        {preview.src && (
          <img
            src={preview.src}
            alt={preview.title}
            style={{
              width: "100%",
              maxHeight: "70vh",
              objectFit: "contain",
              borderRadius: 8,
            }}
          />
        )}
      </Modal>
    </div>
  );
};

export default DropzoneFiltercards;

